export * from './capitalize.pipe';
export * from './plural.pipe';
export * from './round.pipe';
export * from './timing.pipe';



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/@theme/pipes/index.ts